import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaWhatsapp, FaInstagram, FaTiktok, FaEnvelope } from 'react-icons/fa';
import { BsChatText } from 'react-icons/bs';

function LinktreePage() {
  const { t } = useTranslation();
  
  const links = [
    {
      title: "WhatsApp",
      subtitle: "",
      url: "https://wa.me/905372243441",
      icon: <FaWhatsapp size={28} />,
      bgColor: "bg-gradient-to-r from-green-500 to-green-600",
      hoverColor: "hover:from-green-600 hover:to-green-700"
    },
    {
      title: "iMessage",
      subtitle: "",
      url: "sms:+905383833008",
      icon: <BsChatText size={28} />,
      bgColor: "bg-gradient-to-r from-blue-500 to-blue-600",
      hoverColor: "hover:from-blue-600 hover:to-blue-700"
    },
    {
      title: "Instagram",
      subtitle: "@weddingram.me",
      url: "https://instagram.com/weddingram.me",
      icon: <FaInstagram size={28} />,
      bgColor: "bg-gradient-to-r from-purple-500 to-pink-500",
      hoverColor: "hover:from-purple-600 hover:to-pink-600"
    },
    {
      title: "TikTok",
      subtitle: "@weddingram.me",
      url: "https://tiktok.com/@weddingram.me",
      icon: <FaTiktok size={28} />,
      bgColor: "bg-gradient-to-r from-black to-gray-800",
      hoverColor: "hover:from-gray-900 hover:to-black"
    },
    {
      title: "E-Mail",
      subtitle: "weddingram.me@gmail.com",
      url: "mailto:weddingram.me@gmail.com",
      icon: <FaEnvelope size={28} />,
      bgColor: "bg-gradient-to-r from-red-500 to-orange-500",
      hoverColor: "hover:from-red-600 hover:to-orange-600"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8 bg-gradient-to-br from-purple-100 via-pink-50 to-blue-100">
      <div className="w-full max-w-md">
        {/* Profile Section */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-4">
            <span className="text-6xl">💖</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Weddingram
          </h1>
          <p className="text-gray-600 text-sm">
            {t('general.freeTrialText')}
          </p>
        </div>

        {/* Links Section */}
        <div className="space-y-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-auto max-w-xs mx-auto ${link.bgColor} ${link.hoverColor} text-white rounded-2xl p-4 flex items-center justify-between transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105`}
            >
              <div className="flex items-center space-x-2">
                <div className="flex-shrink-0">
                  {link.icon}
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-lg">{link.title}</h3>
                  <p className="text-sm opacity-90">{link.subtitle}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Back to Home */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="text-gray-600 hover:text-gray-800 font-medium transition-colors duration-200"
          >
            ← {t('general.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LinktreePage; 